<template>
  <v-container fluid>
    <base-material-card color="primary" icon="mdi-file-table-box-multiple-outline" inline class="px-5 py-3">
      <template v-slot:after-heading>
        <div>
          BDGD
          <v-progress-circular v-if="loading" size="20" indeterminate color="rgba(0, 0, 0, 0.87)" />
          <span v-else>
            {{ bdgdVersao.ordinaria ? 'Ordinária' : '' }}
            {{ bdgdVersao.data_registro | formatToMonth }} v{{ bdgdVersao.versao }}
          </span>
          x SAMP
        </div>
      </template>
      <v-row>
        <v-col cols="12" class="d-flex flex-row-reverse">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div class="mt-n10" v-bind="attrs" v-on="on">
                <v-btn
                  icon
                  color="black"
                  :loading="loadingDownloadTestesSamp"
                  v-bind="attrs"
                  @click="downloadTestesSamp"
                  v-on="on"
                >
                  <v-icon size="22">mdi-download</v-icon>
                </v-btn>
              </div>
            </template>
            Baixar testes SAMP
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div class="mt-n10" v-bind="attrs" v-on="on">
                <v-btn
                  icon
                  color="black"
                  :loading="loadingExecucaoTestesSamp"
                  v-bind="attrs"
                  @click="dialogExecutarTestesSamp = true"
                  v-on="on"
                >
                  <v-icon size="22">mdi-refresh</v-icon>
                </v-btn>
              </div>
            </template>
            Executar testes SAMP
          </v-tooltip>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-tabs v-model="tabsLevel1" centered>
            <v-tabs-slider></v-tabs-slider>
            <v-tab href="#importacoes-samp" class="primary--text">Importações SAMP</v-tab>
            <v-tab
              v-for="testeAneel in testesAneelAtivos"
              :key="testeAneel.slug"
              :value="testeAneel.slug"
              :href="`#${testeAneel.slug}`"
              class="primary--text"
            >
              {{ testeAneel.nome }}
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tabsLevel1">
            <v-tab-item class="my-5" value="importacoes-samp">
              <v-alert color="info" text class="mt-6">
                Esta aba apresenta um resumo das importações realizadas para cada base (SAMP, SISGD, SIGA e SIG-R) da versão da
                BDGD selecionada.
              </v-alert>
              <v-row class="mt-4">
                <v-col cols="6">
                  <tabela-resumo-importacoes-bases-sisgd class="mb-2" :bdgdVersao="bdgdVersao" />
                  <tabela-resumo-importacoes-bases-samp :bdgdVersao="bdgdVersao" />
                </v-col>
                <v-col cols="6">
                  <tabela-resumo-importacoes-bases-siga class="mb-2" />
                  <tabela-resumo-importacoes-bases-sigr :bdgdVersao="bdgdVersao" />
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item v-for="testeAneel in testesAneelAtivos" :key="testeAneel.slug" :value="testeAneel.slug">
              <v-row class="mt-4">
                <v-col cols="12">
                  <v-alert v-if="testeAneel.descricao" text color="info">
                    <v-row align="center" no-gutters>
                      <v-col class="grow">
                        {{ testeAneel.descricao }}
                      </v-col>
                    </v-row>
                  </v-alert>
                  <v-progress-circular v-if="loading" size="20" indeterminate color="rgba(0, 0, 0, 0.87)" />
                  <div v-else>
                    <v-alert color="info" text class="mb-8 mt-2">
                      {{ explicacaoAba[testeAneel.nome] }} {{ testeAneel.nome }}
                    </v-alert>
                    <component
                      :is="getTabelaResultadoTesteAneel(testeAneel)"
                      class="mt-4"
                      :bdgdVersao="bdgdVersao"
                      :testeAneel="testeAneel"
                      :numExecucaoTestesSamp="numExecucaoTestesSamp"
                    />
                  </div>
                </v-col>
              </v-row>
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
    </base-material-card>
    <v-dialog v-model="dialogExecutarTestesSamp" max-width="450px" @click:outside="dialogExecutarTestesSamp = false">
      <v-card>
        <v-card-title class="headline-custom">Executar testes SAMP:</v-card-title>
        <v-card-text style="font-size: 15px !important">
          <v-radio-group v-model="executarAbasTestes" mandatory row>
            <v-radio label="Somente aba atual" value="ATUAL" />
            <v-radio label="Todas as abas" value="TODAS" />
          </v-radio-group>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn color="green darken-1" text @click="dialogExecutarTestesSamp = false">Cancelar</v-btn>
          <v-btn color="green darken-1" @click="executarTestesSamp">Executar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import dayjs from 'dayjs';
  import ValidacoesSampService from '@/services/ValidacoesSampService';
  import TabelaResumoImportacoesBasesSamp from '@/components/geracao-bdgd/samp/resumos-importacoes/TabelaResumoImportacoesBasesSamp.vue';
  import TabelaResumoImportacoesBasesSiga from '@/components/geracao-bdgd/samp/resumos-importacoes/TabelaResumoImportacoesBasesSiga.vue';
  import TabelaResumoImportacoesBasesSigr from '@/components/geracao-bdgd/samp/resumos-importacoes/TabelaResumoImportacoesBasesSigr.vue';
  import TabelaResumoImportacoesBasesSisgd from '@/components/geracao-bdgd/samp/resumos-importacoes/TabelaResumoImportacoesBasesSisgd.vue';
  import TesteBeSigrXSampAnoGwh from '@/components/geracao-bdgd/samp/tabelas-resultados/TesteBeSigrXSampAnoGwh.vue';
  import TesteEneXBeSigrAnoGwh from '@/components/geracao-bdgd/samp/tabelas-resultados/TesteEneXBeSigrAnoGwh.vue';
  import TesteCegSisgd from '@/components/geracao-bdgd/samp/tabelas-resultados/TesteCegSisgd.vue';
  import TesteCegSiga from '@/components/geracao-bdgd/samp/tabelas-resultados/TesteCegSiga.vue';
  import TesteUntratXEpSigrMwh from '@/components/geracao-bdgd/samp/tabelas-resultados/TesteUntratXEpSigrMwh.vue';
  import TesteBeSigrXSampMwh from '@/components/geracao-bdgd/samp/tabelas-resultados/TesteBeSigrXSampMwh.vue';
  import TesteEneXBeSigrMwh from '@/components/geracao-bdgd/samp/tabelas-resultados/TesteEneXBeSigrMwh.vue';
  import TesteEneSigrXEneSampMwh from '@/components/geracao-bdgd/samp/tabelas-resultados/TesteEneSigrXEneSampMwh.vue';
  import profilePermissionsMixin from '@/mixins/profilePermissionsMixin';

  export default {
    name: 'ValidacoesSamp',
    components: {
      TabelaResumoImportacoesBasesSamp,
      TabelaResumoImportacoesBasesSiga,
      TabelaResumoImportacoesBasesSigr,
      TabelaResumoImportacoesBasesSisgd,
      TesteBeSigrXSampAnoGwh,
      TesteEneXBeSigrAnoGwh,
      TesteCegSisgd,
      TesteCegSiga,
      TesteUntratXEpSigrMwh,
      TesteBeSigrXSampMwh,
      TesteEneXBeSigrMwh,
      TesteEneSigrXEneSampMwh
    },
    mixins: [profilePermissionsMixin],
    data: () => ({
      tabsLevel1: null,
      loading: false,
      loadingDownloadTestesSamp: false,
      loadingExecucaoTestesSamp: false,
      testesAneelAtivos: [],
      numExecucaoTestesSamp: 0,
      dialogExecutarTestesSamp: false,
      executarAbasTestes: 'ATUAL',
      explicacaoAba: {
        'BE SIGR X SAMP ANO GWH':
          'Esta aba apresenta uma tabela comparativa da energia anual (em GWh) entre o SAMP e o SIG-R por origem, para a versão da BDGD selecionada. A tabela exibe o status da verificação, o percentual de energia do SAMP em relação ao SIG-R, a energia anual do SAMP e a energia anual do SIG-R. Ao final, são exibidos o total de cada fonte e as diferenças absoluta e percentual entre elas.',
        'ENE x BE SIGR ANO GWH':
          'Esta aba apresenta uma tabela comparativa da energia anual (em GWh) entre as Unidades Consumidoras (UC) e o Balanço de Energia (BE) por origem, para a versão da BDGD selecionada. A tabela exibe o status da verificação, o percentual de UC em relação ao BE, a energia anual das UCs e a energia anual do BE. Ao final, são exibidos o total de cada fonte, a diferença absoluta entre elas (UC − BE) e o percentual de desconto FOD — indicando se esse valor ultrapassa o limite estabelecido pela ANEEL para empresas de pequeno, médio ou grande porte.',
        'CEG SISGD':
          'Esta aba apresenta uma tabela de conciliação entre os CEGs do SISGD e os CEGs da BDGD por entidade, para a versão da BDGD selecionada. A tabela exibe a quantidade de CEGs em cada base, o status da conciliação, os registros não declarados na BDGD, os repetidos e os conciliados. Ao final, são exibidos os totais e indicado se os percentuais de não conciliados, repetidos e BDGD ultrapassam os limites estabelecidos pela ANEEL.',
        'CEG SIGA':
          'Esta aba apresenta uma tabela de conciliação entre as unidades geradoras da BDGD e do BIG por grupo de tensão, para a versão da BDGD selecionada. A tabela exibe o status da conciliação de cada grupo, bem como a quantidade de unidades geradoras (UG) na BDGD e no BIG. Ao final, são exibidos o total de cada base e indicado se o percentual de conciliação atingiu 100%, sinalizando erro caso contrário.',
        'UNTRAT x EP SIGR MWH':
          'Esta aba apresenta uma tabela comparativa de energia (em MWh) entre as Unidades Transformadoras de Alta Tensão (UNTRAT) e a energia do SIG-R, organizada por tipo de alocação e subgrupos primário e secundário, para a versão da BDGD selecionada. A tabela exibe o status de validação, a energia SIG-R — representada pelas colunas ENE_* — e a energia UNTRAT — representada pelas colunas ENE_TR_* —, sendo o percentual P_ENE_* calculado pela relação ENE_* / ENE_TR_*. Os dados são apresentados primeiro em visão anual e, em seguida, detalhados para cada um dos doze meses do ano. A última coluna indica a quantidade de transformadores considerados, e ao final da tabela são exibidos os totais de cada coluna.',
        'BE SIGR x SAMP MWH':
          'Esta aba apresenta uma tabela comparativa de energia (em MWh) entre as Unidades Transformadoras de Alta Tensão (UNTRAT) e a energia do SIG-R, organizada por tipo de alocação e subgrupos primário e secundário, para a versão da BDGD selecionada. A tabela exibe o status de validação, a energia SIG-R — representada pelas colunas `ENE_*` — e a energia UNTRAT — representada pelas colunas `ENE_TR_*` —, sendo o percentual `P_ENE_*` calculado pela relação `ENE_* / ENE_TR_*`. Os dados são apresentados primeiro em visão anual e, em seguida, detalhados para cada um dos doze meses do ano. A última coluna indica a quantidade de transformadores considerados, e ao final da tabela são exibidos os totais de cada coluna.',
        'ENE x BE SIGR MWH':
          'Esta aba apresenta uma tabela comparativa de energia (em MWh) entre a energia das unidades consumidoras (UC) e o balanço de energia do SIG-R (BE), organizada por origem da energia e subgrupo, para a versão da BDGD selecionada. A tabela exibe a quantidade de UCs (NU), o status de validação, a energia das unidades consumidoras — representada pelas colunas UC_ENE_* — e o balanço de energia do SIG-R — representado pelas colunas BE_ENE_* —, sendo o percentual P_ENE_* calculado pela relação UC_ENE_* / BE_ENE_*. Os dados são apresentados primeiro em visão anual e, em seguida, detalhados para cada um dos doze meses do ano. Ao final da tabela são exibidos os totais de cada coluna.',
        'ENE SIGR x ENE SAMP MWH':
          'Esta aba apresenta uma tabela comparativa de energia (em MWh) entre a energia do SIG-R e a energia do SAMP, organizada por origem da energia, classe e subgrupo, para a versão da BDGD selecionada. A tabela exibe o status de validação, o percentual de número de unidades consumidoras (P_NUC) — calculado pela relação NUC_SAMP / NUC_SIGR — e as quantidades de unidades consumidoras SAMP e SIG-R — representados pelas colunas NUC_SAMP e NUC_SIGR —, além da energia SAMP e SIG-R — representadas pelas colunas ENE_*_SAMP e ENE_*_SIGR —, sendo o percentual P_ENE_* calculado pela relação ENE_*_SAMP / ENE_*_SIGR. Os dados são apresentados primeiro em visão anual e, em seguida, detalhados para cada um dos doze meses do ano. As linhas podem ser expandidas para exibir o detalhamento por subgrupo, e ao final da tabela são exibidos os totais de cada coluna.'
      }
    }),
    computed: {
      bdgdVersao() {
        return this.$store.getters.getUserSelectedCompanyBdgdVersion;
      }
    },
    mounted() {
      this.getTestesAneelAtivos();
    },
    methods: {
      getTestesAneelAtivos() {
        this.loading = true;
        ValidacoesSampService.getTestesAneelAtivos()
          .then((response) => {
            this.testesAneelAtivos = response.data.data;
          })
          .catch((err) => {
            console.log('Erro: ', err);
            this.$toast.error('Erro ao buscar os testes ANEEL ativos no sistema.', '', {
              position: 'topRight'
            });
          })
          .finally(() => (this.loading = false));
      },
      getTabelaResultadoTesteAneel(testeAneel) {
        return `Teste${testeAneel.classe}`;
      },
      executarTestesSamp() {
        this.dialogExecutarTestesSamp = false;
        this.loadingExecucaoTestesSamp = true;
        const executarTodosTestes = this.executarAbasTestes === 'TODAS';
        ValidacoesSampService.executarTestesSamp(this.bdgdVersao.id, {
          executarTodosTestes,
          testeSelecionado: executarTodosTestes ? null : this.tabsLevel1
        })
          .then(() => {
            this.$toast.success('Testes SAMP executados com sucesso.', '', {
              position: 'topRight'
            });
            this.numExecucaoTestesSamp++;
          })
          .catch(() => {
            this.$toast.error('Erro ao tentar executar os testes SAMP.', '', {
              position: 'topRight'
            });
          })
          .finally(() => (this.loadingExecucaoTestesSamp = false));
      },
      downloadTestesSamp() {
        this.loadingDownloadTestesSamp = true;
        ValidacoesSampService.baixarResultadoCompletoTestes(this.bdgdVersao.id, {
          timeout: 60 * 60 * 1000
        })
          .then((res) => {
            const timestamp = dayjs(new Date()).format('YYYYMMDDHHmm');
            const arquivo = `resultado-testes-samp-${timestamp}.xlsx`;
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', arquivo);
            document.body.appendChild(link);
            link.click();
          })
          .catch(() => {
            this.$toast.error('Falha no download do arquivo resultado.', '', {
              position: 'topRight'
            });
          })
          .finally(() => (this.loadingDownloadTestesSamp = false));
      }
    }
  };
</script>

<style>
  .table-samp-result table thead tr th,
  .table-samp-result table tbody tr td,
  .table-samp-result table tfoot tr td {
    font-size: 12px;
    white-space: nowrap;
    padding: 0px 8px !important;
  }
  .table-samp-result table thead tr th {
    font-weight: 500;
  }
  .zebra1 {
    background-color: #fafafa;
  }
  .zebra2 {
    background-color: #f9fbe7;
  }
  .status-samp-ok {
    font-size: 8px !important;
    background-color: #c6efce;
    color: #006100;
  }
  .status-samp-erro {
    font-size: 8px !important;
    background: #ffc7ce;
    color: #9c0006;
  }
  .status-samp-alerta {
    font-size: 8px !important;
    background: #ffeb9c;
    color: #9c5700;
  }
</style>
